const $inject = []
export default class SupportController {
  constructor() {
  }
}
SupportController.$inject = $inject;
